export default "__VITE_ASSET__acf0a27b__"